// src/routes/ProtectedRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state)=>state.auth.user)
  console.log('is authenticated',user, isAuthenticated)

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
